
<div class="card" *ngIf="sourceUrl === null">
  <p class="card-title"><i class="flaticon-layers"></i> {{pageHeadTitle ? pageHeadTitle : "PROCESSES"}}</p>  
  <app-process-list>
  </app-process-list>
</div>
<div class="card" *ngIf="sourceUrl !== null">
  <p class="card-title"><i class="flaticon-layers"></i> {{pageHeadTitle ? pageHeadTitle : "PROCESSES"}}</p>  
  <app-process-grid>
  </app-process-grid>
</div>